module.exports = __webpack_public_path__ + "media/images/profile/profile-2c2e88d136408091fc0586686eae5791.png";